import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

interface ReviewCompleteProps {
  transferDetails: {
    title?: string;
    id?: string;
    subtitle?: string;
  };
}

    const ReviewComplete: React.FC<ReviewCompleteProps> = ({ transferDetails }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/dashboard');
    };

    return (
        <div style={{ backgroundColor: 'white', height: '100%', minHeight: '440px' }}>
        <Result
            status="success"
            title={transferDetails?.title}
            subTitle={transferDetails?.subtitle}
            extra={[
                <Button key="buy" onClick={handleClick}>Dashboard</Button>,
            ]}
        />
        </div>
    );
};

export default ReviewComplete;
